<template>
  <div>

  <!-- Site Footer-->
    <footer class="site-footer">

      <div class="column text-center">
       <h3 class="widget-title text-center"><strong> MENU </strong></h3>
          <div class=" text-center"> <strong> <li><a href="https://luxuryshopdz.com/#/all"> <font color="black">TOUS</font> </a></li></strong> </div>
            <div class=" text-center">  <strong> <li><a href="https://luxuryshopdz.com/#/men"> <font color="black">HOMME</font> </a></li></strong></div>
            <div class=" text-center"> <strong> <li><a href="https://luxuryshopdz.com/#/women"> <font color="black">FEMME</font> </a></li></strong></div>
             <div class=" text-center"> <strong> <li><a href="https://luxuryshopdz.com/#/top"> <font color="red">TOP MODÉLES</font> </a></li></strong></div>
            <div class=" text-center"> <strong> <li><a href="https://luxuryshopdz.com/#/festina"> <font color="black">FESTINA</font> </a></li></strong></div>
           <div class=" text-center"> <strong> <li><a href="https://luxuryshopdz.com/#/Michaelkors"> <font color="black">MICHAEL KORS</font> </a></li></strong></div>
          <div class=" text-center"> <strong> <li><a href="https://luxuryshopdz.com/#/armani"> <font color="black">ARMANI EXCHANGE</font> </a></li></strong></div>
           <div class=" text-center"> <strong> <li><a href="https://luxuryshopdz.com/#/fossil"> <font color="black">FOSSIL</font> </a></li></strong></div>
          <div class=" text-center">  <strong> <li><a href="https://luxuryshopdz.com/#/diesel"> <font color="black">DIESEL</font> </a></li></strong></div>
          <div class=" text-center">  <strong> <li><a href="https://luxuryshopdz.com/#/connectee"> <font color="black">DIESEL</font> </a></li></strong></div>



      </div>
       <div class="column text-center">
       <h3 class="widget-title text-center"><strong>  </strong></h3>
          <div class=" text-center"> <strong> <li><a href="https://luxuryshopdz.com/#/contact"> <font color="black">CONTACT</font> </a></li></strong> </div>
            <div class=" text-center">  <strong> <li><a href="https://luxuryshopdz.com/#/"> <font color="black">ACCUEIL</font> </a></li></strong></div>



      </div>
      <div class="column text-center">
        <p class="text-sm mb-4"><strong> Besoin de soutien? appelez au </strong><span class="text-primary">&nbsp; <strong>023 804 474 / 021 43 62 72</strong></span></p><a class="social-button sb-facebook" href="https://www.facebook.com/LUXURYSHOPDZ/" data-toggle="tooltip" data-placement="top" title="Facebook"><i class="socicon-facebook"></i></a><a class="social-button sb-instagram" href="https://www.instagram.com/luxury.shop_dz_1/?hl=en" data-toggle="tooltip" data-placement="top" title="Instagram"><i class="socicon-instagram"></i></a>
      </div>
      <div class="column">
        <h3 class="widget-title text-center"><strong> Abonnement</strong><small><strong> <font color="black">Pour recevoir les dernières offres et remises de la boutique.</font></strong></small></h3>

      </div>
      <div class="column">
        <h3 class="widget-title text-center"><strong> MODES DE PAIEMENT </strong><small><strong>  <font color="black">Vous payez à la livraison</font></strong> </small></h3>
        <div>
        </div>
      </div>

    </footer>





    <!-- Back To Top Button--><a class="scroll-to-top-btn" href="#"><i class="material-icons trending_flat"></i></a>
    <!-- Backdrop-->
    <div class="site-backdrop"></div>
  </div>


</template>

<script>
export default {};
</script>

<style scoped>

</style>





// WEBPACK FOOTER //
// src/components/mhdfooter.vue